<div class="container-fluid" *ngIf="invoiceDetails && invoiceDetails.length > 0; else elseBlock">
    <div class="row">
        <!-- First Section -->
        <div class="col-md-12" #printContent>
            <div class="col-custom px-6 pt-5 existing" style="flex-basis: 65%">
                <div class="row ml-0 mb-1">
                    <ng-container
                        *ngIf="
                            schoolDetails.profileimg &&
                                showSchoolLogo;
                            else noSchoolLogo
                        "
                    >
                        <img
                            alt="app logo"
                            [src]="schoolDetails.profileimg"
                            class="shadow-4 border-circle flex-shrink-0"
                            style="width: 50px; height: 50px"
                            (error)="onSchoolLogoError()"
                        />
                    </ng-container>
                    <ng-template #noSchoolLogo>
                        <div
                            class="school-logo d-flex align-items-center justify-content-center border-circle shadow-4 flex-shrink-0"
                            [style.background-color]="
                                getBackgroundColor(schoolDetails.id ?? 0)
                            "
                            style="
                                width: 50px;
                                height: 50px;
                                font-size: 20px;
                                color: #fff;
                            "
                        >
                            {{
                                getInitials(
                                    schoolDetails.name ?? ""
                                )
                            }}
                        </div>
                    </ng-template>
                    <div class="mx-3"></div>
                    <span class="app-name mt-2 text-lg font-semibold"
                        >{{ schoolDetails.name }}<br /><span
                            class="font-normal text-base"
                            >{{
                                schoolDetails.description
                            }}</span
                        >
                        <br /><span class="font-normal text-base"
                            >{{ this.addressDetails!.line }},{{
                                this.addressDetails!.city
                            }},{{ this.addressDetails!.state }},{{
                                this.addressDetails!.country
                            }},{{ this.addressDetails!.zipcode }}</span
                        ></span
                    >
                </div>
                <div class="flex flex-column md:flex-row md:align-items-center md:justify-content-between my-3 gap-3">
                    <div class="flex align-items-center">
                        <div class="ml-1 mr-2">
                            <span class="text-lg font-medium block">Billed for :</span>
                        </div>

                        <img [src]="studentDetails?.profileimg"
                            class="border-circle border-2 border-primary inline-block profileImage mr-1"
                            alt="Place image title" *ngIf="
                                studentDetails?.profileimg !=
                                    undefined;
                                else noImageFound
                            " />

                        <ng-template #noImageFound>
                            <div class="circle flex justify-content-center align-items-center mr-1"
                                [style.background-color]="
                                    getBackgroundColor(studentDetails?.id)
                                ">
                                {{ getInitials(studentDetails?.fullName) }}
                            </div>
                        </ng-template>
                        <div class="ml-3">
                            <span class="text-m font-light"><span class="font-normal">
                                    <!-- <b>{{invoiceData.data.invoiceObj.fullName}}</b></span> -->
                                    <b>{{ studentDetails?.fullName }}</b></span>
                                <br />
                                {{ studentDetails?.roomName }}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row mt-2">
                    <!-- Header Section -->
                    <div class="col-12 flex p-2 border-round-top" style="max-height: 27px">
                        <div class="pl-2 text-700">
                            Invoice Number :
                            <span class="text-lg font-medium">
                                {{
                                    invoiceForm.invoiceNumber
                                        ? invoiceForm.invoiceNumber
                                        : ""
                                }}
                            </span>
                        </div>
                    </div>
                    <br />
                    <div class="col-12 flex p-2 border-round-top" style="max-height: 27px">
                        <div class="pl-2 text-700">
                            Due Date :
                            <span class="text-lg font-medium">
                                {{
                                    invoiceForm.dueDate
                                        ? (invoiceForm.dueDate | momentDate)
                                        : ""
                                }}
                            </span>
                        </div>
                    </div>
                    <br />
                    <div class="col-12 flex p-2" style="max-height: 27px">
                        <div class="pl-2 text-700" *ngIf="invoiceForm.startDate != null">
                            Invoice Period :
                            <span class="text-lg font-medium">
                                {{
                                    invoiceForm.startDate
                                        ? (invoiceForm.startDate | momentDate)
                                        : ""
                                }}
                                to
                                {{
                                    invoiceForm.endDate
                                        ? (invoiceForm.endDate | momentDate)
                                        : ""
                                }}
                            </span>
                        </div>
                    </div>

                    <div class="col-12 flex p-2 pt-1">
                        <div class="p-2 col-8 text-center md:text-left">
                            <span class="text-700 block">Description</span>
                        </div>

                        <div class="p-2 col-4 text-center md:text-right">
                            <span class="text-700 block">Amount</span>
                        </div>
                    </div>
                    <div class="col-12 flex justify-content-between surface-border py-0 px-2"></div>
                    <!-- Data Rows -->
                    <div *ngFor="let item of invoiceDetails" class="col-12 flex p-2" style="max-height: 48px">
                        <div class="p-2 col-8 text-center md:text-left">
                            <span class="text-lg font-medium block">{{
                                item.description
                            }}</span>
                        </div>

                        <div class="p-2 col-4 text-center md:text-right">
                            <span class="text-lg block">$
                                {{
                                    item.type == "discount" ||
                                    item.type == "subsidy"
                                        ? "-"
                                        : ""
                                }}{{ item.amount | number:'1.2-2'}}</span>
                        </div>
                    </div>
                    <!-- Add border after each row -->
                    <div class="col-12 flex justify-content-between surface-border py-0 px-2"></div>
                    <div class="col-12 flex p-2 border-round-bottom" style="padding: 10px !important; background : linear-gradient(to right, rgba(111, 140, 255, 0.2), rgba(156, 132, 255, 0.2)) !important;">
                        <div class="p-2 col-8 text-center md:text-left">
                            <span class="text-xl">Total Amount</span>
                        </div>
                        <div class="p-2 col-4 text-center md:text-right">
                            <span class="text-xl font-medium">${{ invoiceForm.invoiceAmount | number:'1.2-2'}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col pl-0 pb-0 no-print" *ngIf="!this.invoiceData.data.isAccountList">
                <div class="d-flex justify-content-center">
                    <p-button label="View" (click)="printInvoice(true)"></p-button>
                    <div class="mx-2"></div>
                    <p-button label="Download" (click)="printInvoice(false)"></p-button>
                </div>
            </div>
            <div class="col pr-0 pb-0 no-print" *ngIf="this.invoiceData.data.isAccountList">
                <div class="d-flex justify-content-center">
                    <div class="mx-2"></div>
                    <button pButton label="Send Invoice" [loading]="submitForm" (click)="sendInvoice()"></button>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #elseBlock>
    <div class="container-fluid">
        <div class="card-form" style="display: flex; align-items: center; justify-content: center">
            <p-progressSpinner [style]="{ width: '45px', height: '37px' }" styleClass="custom-spinner" strokeWidth="8"
                fill="var(--surface-ground)" animationDuration=".9s"></p-progressSpinner>
        </div>
    </div>
</ng-template>
